import type { SearchAddress$result } from '$houdini';
import type { Result } from '../types';
import * as m from '$paraglide/messages';

// Since a coord can only go from -180 to +180, putting 200 in every field now means that it's a fake "My location"
export const VIRTUAL_MY_LOC_COORD = 200;

export function myLocResult(): SearchAddress$result['searchAddress'][number] {
	return {
		score: 0,
		formattedName: m.itinerary__current_location(),
		contextualizedName: null,
		entityType: null,
		address: {
			city: null,
			country: {
				code: '',
			},
			zipCode: null,
			department: null,
			region: null,
		},
		mapLocation: {
			location: {
				lng: VIRTUAL_MY_LOC_COORD,
				lat: VIRTUAL_MY_LOC_COORD,
			},
			viewPort: {
				northeast: {
					lat: VIRTUAL_MY_LOC_COORD,
					lng: VIRTUAL_MY_LOC_COORD,
				},
				southwest: {
					lat: VIRTUAL_MY_LOC_COORD,
					lng: VIRTUAL_MY_LOC_COORD,
				},
			},
		},
	};
}

export function isMyLocation(result: Result): boolean {
	return (
		'mapLocation' in result
		&& result?.mapLocation.location.lat === VIRTUAL_MY_LOC_COORD
		&& result?.mapLocation.location.lng === VIRTUAL_MY_LOC_COORD
	);
}
